<div
  class="border-t border-surface-200 dark:border-surface-700 my-1"
  role="separator"
></div>
